export const videos = [
  {
    id: "v-movie-01",
    title: "星际边境",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20space%20station%20interior%20with%20cool%20teal%20green%20lighting%2C%20silhouette%20of%20a%20lone%20astronaut%20facing%20a%20glowing%20observation%20window%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20consistent%20color%20palette%2C%20editorial%20movie%20poster%20photography&width=800&height=450&seq=hg-movie-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=wide%20cinematic%20sci-fi%20space%20station%20observation%20deck%20with%20vast%20glowing%20planet%20view%2C%20cool%20teal%20green%20lighting%2C%20lone%20astronaut%20silhouette%2C%20epic%20minimal%20composition%2C%20high%20detail%2C%20muted%20consistent%20palette%2C%20movie%20poster%20photography&width=1600&height=900&seq=hg-hero-movie-01&orientation=landscape",
    region: "美国",
    year: "2025",
    quality: "4K",
    duration: "128分钟",
    uploadDate: "2026-10-12",
    views: 268000,
    tags: ["科幻", "冒险", "太空", "4K"],
    summary: "一支远航舰队抵达边缘星系，在废弃空间站中发现足以改变人类命运的线索。",
    description:
      "故事围绕一支远航探索舰队展开，他们在星际边境发现一座沉寂多年的空间站，并逐步揭开一段被刻意掩埋的历史。影片以冷峻的色调与克制的叙事呈现宇宙的孤独感，同时保留了对人性与选择的思考。",
    featured: true,
  },
  {
    id: "v-movie-02",
    title: "暗夜追凶",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20neo-noir%20city%20alley%20at%20night%20with%20rain-slicked%20pavement%20and%20tall%20buildings%2C%20warm%20amber%20street%20lamp%20glow%2C%20brooding%20atmosphere%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20green-orange%20palette%2C%20film%20still%20photography&width=800&height=450&seq=hg-movie-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=moody%20neo-noir%20city%20alley%20at%20night%20with%20rain-slicked%20pavement%20and%20tall%20buildings%2C%20warm%20amber%20street%20lamp%20glow%2C%20brooding%20atmosphere%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20green-orange%20palette%2C%20film%20still%20photography&width=800&height=450&seq=hg-movie-02&orientation=landscape",
    region: "美国",
    year: "2024",
    quality: "1080P",
    duration: "116分钟",
    uploadDate: "2026-10-06",
    views: 192000,
    tags: ["犯罪", "悬疑", "推理"],
    summary: "一桩悬置多年的旧案重新浮出水面，刑警在迷雾般的线索中追踪真正的凶手。",
    description:
      "影片以一桩多年悬案为切入点，通过碎片化的线索与层层反转，带观众进入一场缜密的心理博弈。冷色调的夜景与低压的配乐共同营造出紧张氛围，是近年颇具质感的犯罪悬疑类型作品。",
    featured: false,
  },
  {
    id: "v-movie-03",
    title: "长安旧梦",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20ancient%20Chinese%20palace%20courtyard%20with%20red%20lanterns%20and%20misty%20morning%20light%2C%20traditional%20architecture%2C%20graceful%20figure%20in%20flowing%20silk%20robe%2C%20refined%20cinematic%20composition%2C%20high%20detail%2C%20muted%20warm%20palette%2C%20historical%20film%20still&width=800&height=450&seq=hg-movie-03&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=elegant%20ancient%20Chinese%20palace%20courtyard%20with%20red%20lanterns%20and%20misty%20morning%20light%2C%20traditional%20architecture%2C%20graceful%20figure%20in%20flowing%20silk%20robe%2C%20refined%20cinematic%20composition%2C%20high%20detail%2C%20muted%20warm%20palette%2C%20historical%20film%20still&width=800&height=450&seq=hg-movie-03&orientation=landscape",
    region: "中国大陆",
    year: "2025",
    quality: "4K",
    duration: "132分钟",
    uploadDate: "2026-10-10",
    views: 221000,
    tags: ["古装", "剧情", "历史"],
    summary: "盛唐长安的一夜繁华背后，一段被时光掩埋的往事缓缓铺展开来。",
    description:
      "影片以盛唐长安为背景，将宏大的时代气象与个体的命运交织在一起。考究的场景与服饰还原了那个时代的质感，而克制的叙事则将家国与情感的主题娓娓道来，适合喜欢历史题材的观众。",
    featured: false,
  },
  {
    id: "v-movie-04",
    title: "深海迷航",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20underwater%20scene%20with%20rays%20of%20light%20piercing%20blue-green%20water%2C%20adventurous%20submarine%20silhouette%2C%20mysterious%20atmosphere%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20underwater%20documentary%20style%20photography&width=800&height=450&seq=hg-movie-04&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=deep%20ocean%20underwater%20scene%20with%20rays%20of%20light%20piercing%20blue-green%20water%2C%20adventurous%20submarine%20silhouette%2C%20mysterious%20atmosphere%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20underwater%20documentary%20style%20photography&width=800&height=450&seq=hg-movie-04&orientation=landscape",
    region: "英国",
    year: "2024",
    quality: "1080P",
    duration: "108分钟",
    uploadDate: "2026-09-28",
    views: 145000,
    tags: ["冒险", "海洋", "惊险"],
    summary: "深潜队在未知海域遭遇极端环境，一场关于生存与勇气的考验就此开始。",
    description:
      "影片将镜头对准幽深的海底世界，通过紧凑的节奏与逼真的水下场景，呈现一场极限环境下的求生之旅。画面与音效的配合营造出强烈的沉浸感，是一部节奏明快的冒险类型作品。",
    featured: false,
  },
  {
    id: "v-movie-05",
    title: "心动信号",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20romantic%20cafe%20interior%20with%20warm%20afternoon%20light%20and%20blooming%20flowers%20on%20a%20wooden%20table%2C%20cozy%20tender%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20pastel%20palette%2C%20editorial%20romance%20film%20still%20photography&width=800&height=450&seq=hg-movie-05&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=soft%20romantic%20cafe%20interior%20with%20warm%20afternoon%20light%20and%20blooming%20flowers%20on%20a%20wooden%20table%2C%20cozy%20tender%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20pastel%20palette%2C%20editorial%20romance%20film%20still%20photography&width=800&height=450&seq=hg-movie-05&orientation=landscape",
    region: "韩国",
    year: "2025",
    quality: "1080P",
    duration: "104分钟",
    uploadDate: "2026-09-22",
    views: 158000,
    tags: ["爱情", "治愈", "都市"],
    summary: "两个在都市中各自忙碌的年轻人，因一次偶然的相遇慢慢靠近彼此。",
    description:
      "影片用细腻的日常片段描绘一段温柔的都市情感，画面明亮清新，节奏舒缓。它并不追求戏剧性的冲突，而是在细水长流的相处中呈现心动的微妙变化，适合安静地慢慢观看。",
    featured: false,
  },
  {
    id: "v-movie-06",
    title: "烈焰战地",
    categoryId: "movie",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20wartime%20battlefield%20at%20dusk%20with%20smoke%20and%20golden%20ember%20light%2C%20distant%20silhouettes%20of%20soldiers%2C%20intense%20atmosphere%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20amber-green%20palette%2C%20epic%20war%20film%20still&width=800&height=450&seq=hg-movie-06&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=dramatic%20wartime%20battlefield%20at%20dusk%20with%20smoke%20and%20golden%20ember%20light%2C%20distant%20silhouettes%20of%20soldiers%2C%20intense%20atmosphere%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20amber-green%20palette%2C%20epic%20war%20film%20still&width=800&height=450&seq=hg-movie-06&orientation=landscape",
    region: "美国",
    year: "2023",
    quality: "蓝光",
    duration: "141分钟",
    uploadDate: "2026-09-16",
    views: 132000,
    tags: ["战争", "历史", "剧情"],
    summary: "一支小队深入敌后执行任务，在生死边缘重新理解责任与信念的意义。",
    description:
      "影片以战争为背景，通过一支小队的视角展现战场上的抉择与牺牲。宏大的战争场面与细腻的人物刻画相结合，在紧张的情节中传递出对和平的珍视，是一部颇具分量的历史题材作品。",
    featured: false,
  },
  {
    id: "v-tv-01",
    title: "都市晨曦",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20sunrise%20with%20soft%20golden%20light%20reflecting%20on%20glass%20towers%2C%20calm%20urban%20atmosphere%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20editorial%20city%20drama%20still%20photography&width=800&height=450&seq=hg-tv-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20sunrise%20with%20soft%20golden%20light%20reflecting%20on%20glass%20towers%2C%20calm%20urban%20atmosphere%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20editorial%20city%20drama%20still%20photography&width=800&height=450&seq=hg-tv-01&orientation=landscape",
    region: "中国大陆",
    year: "2026",
    quality: "1080P",
    duration: "45分钟/集",
    uploadDate: "2026-10-13",
    views: 204000,
    tags: ["都市", "家庭", "生活"],
    summary: "三代人同住一个屋檐下，在柴米油盐中慢慢理解彼此的选择与坚持。",
    description:
      "这部剧集以一座普通城市为舞台，讲述三代人共同生活的温情故事。它以生活化的细节呈现家庭关系中的摩擦与和解，节奏平实却充满共鸣，适合一家人一起观看。",
    featured: false,
  },
  {
    id: "v-tv-02",
    title: "迷雾档案",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=dim%20investigation%20office%20with%20scattered%20case%20files%20and%20a%20single%20desk%20lamp%2C%20mysterious%20tense%20mood%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20green-grey%20palette%2C%20detective%20series%20still%20photography&width=800&height=450&seq=hg-tv-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=dim%20investigation%20office%20with%20scattered%20case%20files%20and%20a%20single%20desk%20lamp%2C%20mysterious%20tense%20mood%2C%20minimal%20cinematic%20composition%2C%20high%20detail%2C%20muted%20green-grey%20palette%2C%20detective%20series%20still%20photography&width=800&height=450&seq=hg-tv-02&orientation=landscape",
    region: "英国",
    year: "2025",
    quality: "4K",
    duration: "50分钟/集",
    uploadDate: "2026-10-08",
    views: 176000,
    tags: ["悬疑", "推理", "犯罪"],
    summary: "一份尘封多年的档案被重新翻开，牵出一连串彼此关联的谜团。",
    description:
      "剧集采用单元案件与主线交织的结构，每一集都留下新的疑点。冷峻的影像风格与层层递进的悬念共同营造出浓厚的推理氛围，喜欢跟着线索一起抽丝剥茧的观众会很快入戏。",
    featured: false,
  },
  {
    id: "v-tv-03",
    title: "盛世华章",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=grand%20ancient%20Chinese%20throne%20hall%20interior%20with%20golden%20ornaments%20and%20silk%20drapery%2C%20majestic%20atmosphere%2C%20minimal%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20gold%20palette%2C%20period%20drama%20still%20photography&width=800&height=450&seq=hg-tv-03&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=grand%20ancient%20Chinese%20throne%20hall%20interior%20with%20golden%20ornaments%20and%20silk%20drapery%2C%20majestic%20atmosphere%2C%20minimal%20refined%20composition%2C%20high%20detail%2C%20muted%20warm%20gold%20palette%2C%20period%20drama%20still%20photography&width=800&height=450&seq=hg-tv-03&orientation=landscape",
    region: "中国大陆",
    year: "2024",
    quality: "1080P",
    duration: "48分钟/集",
    uploadDate: "2026-09-25",
    views: 219000,
    tags: ["古装", "权谋", "历史"],
    summary: "朝堂之上风云变幻，一群身处其中的人各自走出不同的道路。",
    description:
      "剧集以考究的服化道还原时代风貌，围绕朝堂与江湖双线展开叙事。人物塑造立体，情节张弛有度，在宏大的历史背景中呈现个体命运的选择与坚守。",
    featured: false,
  },
  {
    id: "v-tv-04",
    title: "律政风云",
    categoryId: "tv",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20law%20office%20with%20floor%20to%20ceiling%20windows%20and%20neat%20stacked%20documents%2C%20professional%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20legal%20drama%20still%20photography&width=800&height=450&seq=hg-tv-04&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=modern%20law%20office%20with%20floor%20to%20ceiling%20windows%20and%20neat%20stacked%20documents%2C%20professional%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20legal%20drama%20still%20photography&width=800&height=450&seq=hg-tv-04&orientation=landscape",
    region: "美国",
    year: "2026",
    quality: "1080P",
    duration: "42分钟/集",
    uploadDate: "2026-10-02",
    views: 141000,
    tags: ["职场", "剧情", "律政"],
    summary: "年轻律师踏入顶级律所，在一次次案件中不断面对理想与现实的碰撞。",
    description:
      "剧集聚焦职场成长主题，通过一桩桩案件展开对规则与人情的探讨。紧凑的庭审戏份与人物之间的博弈让剧情富有张力，同时也留下了关于职业信念的思考。",
    featured: false,
  },
  {
    id: "v-variety-01",
    title: "星光舞台",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20concert%20stage%20with%20colorful%20spotlights%20and%20a%20solo%20singer%20silhouette%2C%20energetic%20atmosphere%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20teal-orange%20palette%2C%20music%20competition%20show%20photography&width=800&height=450&seq=hg-variety-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=vibrant%20concert%20stage%20with%20colorful%20spotlights%20and%20a%20solo%20singer%20silhouette%2C%20energetic%20atmosphere%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20teal-orange%20palette%2C%20music%20competition%20show%20photography&width=800&height=450&seq=hg-variety-01&orientation=landscape",
    region: "中国大陆",
    year: "2026",
    quality: "1080P",
    duration: "90分钟",
    uploadDate: "2026-10-11",
    views: 231000,
    tags: ["音乐", "竞技", "舞台"],
    summary: "来自不同背景的歌手同台竞技，用歌声讲述属于自己的故事。",
    description:
      "节目以音乐竞演为核心，汇集多元风格的表演与真诚的幕后记录。每一期都有不同主题与编排，既有舞台上的高光时刻，也有选手之间的相互鼓励，是一档温暖而有力量的音乐综艺。",
    featured: false,
  },
  {
    id: "v-variety-02",
    title: "味觉奇迹",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20cooking%20studio%20with%20fresh%20vegetables%20and%20steaming%20pots%20on%20a%20clean%20counter%2C%20appetizing%20warm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20cooking%20show%20photography&width=800&height=450&seq=hg-variety-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=cozy%20cooking%20studio%20with%20fresh%20vegetables%20and%20steaming%20pots%20on%20a%20clean%20counter%2C%20appetizing%20warm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20cooking%20show%20photography&width=800&height=450&seq=hg-variety-02&orientation=landscape",
    region: "中国大陆",
    year: "2025",
    quality: "1080P",
    duration: "75分钟",
    uploadDate: "2026-09-30",
    views: 167000,
    tags: ["美食", "生活", "治愈"],
    summary: "厨师们走进不同城市，用当地食材烹制出一道道有温度的菜肴。",
    description:
      "节目以美食为线索，走访各地寻找特色食材，记录食物背后的故事与人情。画面温暖清新，节奏舒缓，既能学到实用的烹饪技巧，也能感受到食物连接人心的力量。",
    featured: false,
  },
  {
    id: "v-variety-03",
    title: "环球漫游",
    categoryId: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=scenic%20travel%20landscape%20with%20winding%20road%20through%20misty%20green%20hills%20and%20morning%20light%2C%20adventurous%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20travel%20variety%20show%20photography&width=800&height=450&seq=hg-variety-03&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=scenic%20travel%20landscape%20with%20winding%20road%20through%20misty%20green%20hills%20and%20morning%20light%2C%20adventurous%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20travel%20variety%20show%20photography&width=800&height=450&seq=hg-variety-03&orientation=landscape",
    region: "韩国",
    year: "2026",
    quality: "4K",
    duration: "70分钟",
    uploadDate: "2026-10-05",
    views: 189000,
    tags: ["旅行", "纪实", "风景"],
    summary: "一群年轻人背上行囊，沿着陌生的路线记录沿途风景与人间烟火。",
    description:
      "节目采用轻纪实的方式，跟随嘉宾走访不同地区，感受当地的风土人情。既有令人心旷神怡的自然风光，也有真实自然的互动与临场反应，适合放松时慢慢观看。",
    featured: false,
  },
  {
    id: "v-anime-01",
    title: "幻境物语",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20anime%20key%20visual%20with%20floating%20islands%20and%20glowing%20magical%20forest%2C%20young%20adventurer%20silhouette%2C%20dreamy%20atmosphere%2C%20minimal%20vivid%20composition%2C%20high%20detail%2C%20muted%20teal-green%20palette%2C%20animated%20poster%20illustration&width=800&height=450&seq=hg-anime-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=wide%20fantasy%20anime%20key%20visual%20of%20floating%20islands%20and%20a%20glowing%20magical%20forest%20with%20a%20young%20adventurer%2C%20dreamy%20epic%20atmosphere%2C%20minimal%20vivid%20composition%2C%20high%20detail%2C%20muted%20teal-green%20palette%2C%20animated%20film%20illustration&width=1600&height=900&seq=hg-hero-anime-01&orientation=landscape",
    region: "日本",
    year: "2026",
    quality: "1080P",
    duration: "24分钟/集",
    uploadDate: "2026-10-14",
    views: 258000,
    tags: ["奇幻", "冒险", "番剧"],
    summary: "少年踏上寻找失落之地的旅途，在幻境中结识伙伴并直面命运。",
    description:
      "作品以瑰丽的幻想世界为舞台，讲述少年一路成长的冒险故事。精美的作画与富有想象力的设定相得益彰，情节中既有热血的战斗，也有关于友情与选择的温柔表达。",
    featured: true,
  },
  {
    id: "v-anime-02",
    title: "机甲黎明",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20mecha%20robot%20standing%20in%20a%20neon-lit%20hangar%20at%20dawn%2C%20epic%20scale%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20green-orange%20palette%2C%20sci-fi%20anime%20key%20visual%20illustration&width=800&height=450&seq=hg-anime-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=futuristic%20mecha%20robot%20standing%20in%20a%20neon-lit%20hangar%20at%20dawn%2C%20epic%20scale%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20green-orange%20palette%2C%20sci-fi%20anime%20key%20visual%20illustration&width=800&height=450&seq=hg-anime-02&orientation=landscape",
    region: "日本",
    year: "2025",
    quality: "4K",
    duration: "25分钟/集",
    uploadDate: "2026-10-03",
    views: 202000,
    tags: ["机战", "科幻", "热血"],
    summary: "在被战争笼罩的世界里，一群少年驾驶机甲守护最后的希望。",
    description:
      "作品以机甲战斗为核心，构建了一个充满张力的科幻世界观。战斗分镜流畅震撼，同时对角色之间的羁绊与成长也有充分刻画，是科幻机甲爱好者不容错过的一部番剧。",
    featured: false,
  },
  {
    id: "v-anime-03",
    title: "春日慢行",
    categoryId: "anime",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20slice%20of%20life%20anime%20scene%20of%20a%20quiet%20street%20under%20cherry%20blossoms%2C%20gentle%20spring%20light%2C%20warm%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20pastel%20palette%2C%20anime%20background%20illustration&width=800&height=450&seq=hg-anime-03&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=soft%20slice%20of%20life%20anime%20scene%20of%20a%20quiet%20street%20under%20cherry%20blossoms%2C%20gentle%20spring%20light%2C%20warm%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20pastel%20palette%2C%20anime%20background%20illustration&width=800&height=450&seq=hg-anime-03&orientation=landscape",
    region: "日本",
    year: "2024",
    quality: "1080P",
    duration: "23分钟/集",
    uploadDate: "2026-09-20",
    views: 176000,
    tags: ["日常", "治愈", "青春"],
    summary: "小镇上的少年少女，在四季流转中度过平凡而珍贵的每一天。",
    description:
      "这是一部节奏舒缓的日常系作品，用细腻的画面描绘青春里的点滴小事。没有激烈的冲突，却能在平凡的瞬间传递出温暖与治愈，适合在忙碌之余静静品味。",
    featured: false,
  },
  {
    id: "v-doc-01",
    title: "蓝色星球纪行",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=underwater%20wildlife%20scene%20with%20a%20majestic%20whale%20gliding%20through%20deep%20blue-green%20water%2C%20awe-inspiring%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20ocean%20palette%2C%20nature%20documentary%20photography&width=800&height=450&seq=hg-doc-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=underwater%20wildlife%20scene%20with%20a%20majestic%20whale%20gliding%20through%20deep%20blue-green%20water%2C%20awe-inspiring%20calm%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20ocean%20palette%2C%20nature%20documentary%20photography&width=800&height=450&seq=hg-doc-01&orientation=landscape",
    region: "英国",
    year: "2025",
    quality: "4K",
    duration: "55分钟",
    uploadDate: "2026-09-27",
    views: 198000,
    tags: ["自然", "海洋", "纪实"],
    summary: "跟随镜头潜入深海，走近那些鲜为人知却生机盎然的海洋生命。",
    description:
      "纪录片以极高的画质呈现海洋世界的壮阔与细腻，从浅海珊瑚到幽暗深海，记录各种生物的生存方式。它既是一场视觉盛宴，也唤起人们对自然保护的关注与思考。",
    featured: false,
  },
  {
    id: "v-doc-02",
    title: "深空之眼",
    categoryId: "documentary",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20space%20nebula%20with%20swirling%20colorful%20cosmic%20dust%20and%20distant%20stars%2C%20awe-inspiring%20vast%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20space%20documentary%20photography&width=800&height=450&seq=hg-doc-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=deep%20space%20nebula%20with%20swirling%20colorful%20cosmic%20dust%20and%20distant%20stars%2C%20awe-inspiring%20vast%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20space%20documentary%20photography&width=800&height=450&seq=hg-doc-02&orientation=landscape",
    region: "美国",
    year: "2026",
    quality: "4K",
    duration: "60分钟",
    uploadDate: "2026-10-09",
    views: 175000,
    tags: ["宇宙", "科学", "纪实"],
    summary: "从星系到黑洞，纪录片带你重新认识我们所处的浩瀚宇宙。",
    description:
      "纪录片借助最新的观测影像与三维模拟，将遥远宇宙的壮丽景象呈现在观众眼前。通俗易懂的讲解配合震撼的画面，让复杂的科学知识变得直观而有趣，适合全家一起观看。",
    featured: false,
  },
  {
    id: "v-sport-01",
    title: "绿茵巅峰",
    categoryId: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=football%20stadium%20at%20night%20packed%20with%20fans%20and%20bright%20floodlights%20on%20lush%20green%20pitch%2C%20energetic%20atmosphere%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20sports%20broadcast%20photography&width=800&height=450&seq=hg-sport-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=wide%20night%20football%20stadium%20with%20green%20pitch%2C%20bright%20floodlights%20and%20packed%20cheering%20crowd%2C%20epic%20energetic%20atmosphere%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20green%20palette%2C%20sports%20event%20photography&width=1600&height=900&seq=hg-hero-sport-01&orientation=landscape",
    region: "国际赛事",
    year: "2026",
    quality: "1080P",
    duration: "120分钟",
    uploadDate: "2026-10-13",
    views: 243000,
    tags: ["足球", "赛事", "集锦"],
    summary: "焦点对决高光集锦，进球、扑救与关键瞬间一次看完。",
    description:
      "本片汇集近期焦点赛事的精彩集锦，通过多机位与慢动作回放还原比赛的转折时刻。无论是进球时的欢呼，还是最后时刻的绝杀，都能让球迷重温绿茵场上的澎湃激情。",
    featured: true,
  },
  {
    id: "v-sport-02",
    title: "篮下风暴",
    categoryId: "sports",
    cover:
      "https://readdy.ai/api/search-image?query=indoor%20basketball%20arena%20with%20glossy%20hardwood%20court%20and%20dramatic%20arena%20lighting%2C%20intense%20sporty%20mood%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20amber-green%20palette%2C%20basketball%20broadcast%20photography&width=800&height=450&seq=hg-sport-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=indoor%20basketball%20arena%20with%20glossy%20hardwood%20court%20and%20dramatic%20arena%20lighting%2C%20intense%20sporty%20mood%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20amber-green%20palette%2C%20basketball%20broadcast%20photography&width=800&height=450&seq=hg-sport-02&orientation=landscape",
    region: "美国",
    year: "2025",
    quality: "1080P",
    duration: "110分钟",
    uploadDate: "2026-09-29",
    views: 156000,
    tags: ["篮球", "赛事", "集锦"],
    summary: "热血篮球赛事实录，扣篮、三分与绝杀的燃情时刻回顾。",
    description:
      "影片以赛季精彩瞬间为主线，串联起多场焦点比赛的燃情时刻。精准的镜头捕捉与现场音效让观众仿佛置身球馆，感受篮球运动的速度与力量。",
    featured: false,
  },
  {
    id: "v-music-01",
    title: "声浪现场",
    categoryId: "music",
    cover:
      "https://readdy.ai/api/search-image?query=large%20outdoor%20music%20festival%20stage%20at%20night%20with%20glowing%20crowd%20and%20dramatic%20beam%20lights%2C%20energetic%20mood%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20teal-orange%20palette%2C%20concert%20photography&width=800&height=450&seq=hg-music-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=large%20outdoor%20music%20festival%20stage%20at%20night%20with%20glowing%20crowd%20and%20dramatic%20beam%20lights%2C%20energetic%20mood%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20teal-orange%20palette%2C%20concert%20photography&width=800&height=450&seq=hg-music-01&orientation=landscape",
    region: "国际",
    year: "2026",
    quality: "4K",
    duration: "95分钟",
    uploadDate: "2026-10-07",
    views: 212000,
    tags: ["演唱会", "现场", "流行"],
    summary: "万人音乐节现场实录，灯火与声浪交织成难忘的夜晚。",
    description:
      "本片完整记录一场户外音乐节的演出现场，多支乐队的精彩表演轮番登场。镜头在舞台上下的情绪之间切换，将现场的炽热氛围传递给每一位观众。",
    featured: false,
  },
  {
    id: "v-music-02",
    title: "木吉他时光",
    categoryId: "music",
    cover:
      "https://readdy.ai/api/search-image?query=intimate%20acoustic%20session%20with%20a%20wooden%20guitar%20on%20a%20rustic%20stool%20by%20a%20sunlit%20window%2C%20warm%20nostalgic%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20warm%20palette%2C%20folk%20music%20photography&width=800&height=450&seq=hg-music-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=intimate%20acoustic%20session%20with%20a%20wooden%20guitar%20on%20a%20rustic%20stool%20by%20a%20sunlit%20window%2C%20warm%20nostalgic%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20warm%20palette%2C%20folk%20music%20photography&width=800&height=450&seq=hg-music-02&orientation=landscape",
    region: "中国大陆",
    year: "2025",
    quality: "1080P",
    duration: "88分钟",
    uploadDate: "2026-09-18",
    views: 134000,
    tags: ["民谣", "弹唱", "治愈"],
    summary: "一把木吉他，几段安静旋律，陪你度过一段松弛的午后时光。",
    description:
      "这是一场小型的民谣弹唱现场，没有华丽的舞台，只有真诚的歌声与琴声。画面朴素温暖，气氛安静松弛，适合在午后或夜晚静下心来慢慢聆听。",
    featured: false,
  },
  {
    id: "v-game-01",
    title: "电竞之巅",
    categoryId: "game",
    cover:
      "https://readdy.ai/api/search-image?query=esports%20arena%20with%20large%20glowing%20screens%20and%20players%20at%20gaming%20stations%2C%20futuristic%20competitive%20mood%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20green-orange%20palette%2C%20esports%20event%20photography&width=800&height=450&seq=hg-game-01&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=esports%20arena%20with%20large%20glowing%20screens%20and%20players%20at%20gaming%20stations%2C%20futuristic%20competitive%20mood%2C%20minimal%20dynamic%20composition%2C%20high%20detail%2C%20muted%20green-orange%20palette%2C%20esports%20event%20photography&width=800&height=450&seq=hg-game-01&orientation=landscape",
    region: "中国大陆",
    year: "2026",
    quality: "1080P",
    duration: "100分钟",
    uploadDate: "2026-10-12",
    views: 226000,
    tags: ["电竞", "赛事", "竞技"],
    summary: "顶级电竞赛事全程回顾，战术博弈与精彩操作一次看够。",
    description:
      "本片复盘一场大型电竞比赛的完整过程，从开局布局到决胜团战，逐帧解析双方的关键决策。快节奏的剪辑与专业的解说让观众能快速理解赛场上的策略与博弈。",
    featured: false,
  },
  {
    id: "v-game-02",
    title: "像素回廊",
    categoryId: "game",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20gaming%20room%20with%20vintage%20consoles%20and%20colorful%20pixel%20game%20visuals%20on%20screens%2C%20nostalgic%20playful%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20gaming%20culture%20photography&width=800&height=450&seq=hg-game-02&orientation=landscape",
    heroImage:
      "https://readdy.ai/api/search-image?query=retro%20gaming%20room%20with%20vintage%20consoles%20and%20colorful%20pixel%20game%20visuals%20on%20screens%2C%20nostalgic%20playful%20mood%2C%20minimal%20clean%20composition%2C%20high%20detail%2C%20muted%20teal%20palette%2C%20gaming%20culture%20photography&width=800&height=450&seq=hg-game-02&orientation=landscape",
    region: "日本",
    year: "2025",
    quality: "1080P",
    duration: "65分钟",
    uploadDate: "2026-09-24",
    views: 148000,
    tags: ["游戏文化", "怀旧", "纪实"],
    summary: "从像素时代到如今，走进经典游戏背后的创作故事与文化记忆。",
    description:
      "本片以怀旧为主题，回顾游戏发展历程中的经典作品与创作幕后。通过开发者访谈与影像资料，展现那些陪伴一代人成长的像素画面背后的故事与情怀。",
    featured: false,
  },
];